import { EditorImagesIds, TextColor } from '@setvi/shared/enums';
import { getProductStatus } from 'componentsV2/product/status';
import { GridPricing, Product } from '@setvi/shared/interfaces';

export const getProductCardAsHtml = (
  product: Product,
  manufacturer: boolean
) => {
  const containerWidth = '312px';
  const imageWidth = 'width: 50px; min-width: 50px;';
  const imageHeight = 'height: 37px; min-height: 37px;';
  const fontSize = '14px';
  const textFieldOverflow = `display: -webkit-box; overflow: hidden; text-overflow: ellipsis; -webkit-box-orient: vertical; -webkit-line-clamp: 2; word-break: break-word; line-height: 1.1; font-size: ${fontSize};`;
  const productName = `${textFieldOverflow} margin: auto 0 auto 6px; height: min-content; align-self: center; font-weight: 600;`;
  // @ts-ignore
  const productLink = product.custom.ecommerceLink?.value;
  const hasPrice = typeof product.price === 'number';

  // This encodeURI method is used for replacing spaces with %20 in the image URL to aviod the image not found issue
  const imageSrc = encodeURI(
    product.imageUrl ||
      product.images[0]?.path ||
      'https://euhd1msp.blob.core.windows.net/public/no-product-image.png'
  );

  return `<div id="${product._id}" style="width: ${containerWidth}; min-width: ${containerWidth}; max-width: ${containerWidth}; border: 1px solid ${TextColor.LightGrey}; border-radius: 12px; padding: 12px 10px">
        <div>    
            <div style="display: flex;">
                <div style="${imageWidth} ${imageHeight} border-radius: 2px; overflow: hidden; display: flex">
                  <img id="${EditorImagesIds.PRODUCT}" src=${imageSrc} alt=${product.name} style="object-fit: contain; max-width: 100%; max-height: 100%;  margin: auto;" />
                </div>
                ${
                  productLink
                    ? ` <a href="${productLink}" contenteditable="false" target="_blank" style="${productName} color: #1E96FC; cursor: pointer;">
                          ${product.name}
                        </a>`
                    : `<p style="${productName} color: ${TextColor.Black};">${product.name}</p>`
                }
            </div>
            <p style="${textFieldOverflow} color: ${TextColor.Grey}; padding-top: 8px">
                SKU: ${product.sku} (${getProductStatus(product)})
            </p>
        </div>
        <div style="padding: 8px 0 ${hasPrice ? '8px' : '0'} 0; border-top: 1px solid #E6E7E9; margin-top: 8px">
            <p style="${textFieldOverflow} font-size: ${fontSize} color: ${TextColor.Black}">${
              product?.vendor?.name
                ? `MFG: ${product?.vendor?.name}`
                : 'Not Available'
            }</p>
            ${!manufacturer ? `<p style="font-size: ${fontSize}; color: ${TextColor.Grey}; padding-top: 6px">${product.manufacturerSku}</p>` : ''}
        </div>
        ${
          hasPrice
            ? `<p style="border-top: 1px solid #E6E7E9; padding-top: 8px; font-size: ${fontSize}; font-weight: 600">Sell: ${(
                product?.price || 0
              ).toLocaleString('en-US', {
                currency: 'USD',
                style: 'currency'
              })}</p>`
            : ''
        }
      </div>`;
};

export const calculateHeight = (items: GridPricing[]) => {
  let totalHeight = 0;
  let itemsInRow = 0;
  let isFirstRow = true;

  // eslint-disable-next-line no-plusplus
  for (let i = 0; i < items.length; i++) {
    const item = items[i];

    if (item.fullWidth) {
      if (!isFirstRow) totalHeight += 8; // gap before new row
      totalHeight += 18;
      isFirstRow = false;
      itemsInRow = 0; // reset row
    } else {
      if (itemsInRow === 0 && !isFirstRow) {
        totalHeight += 8; // gap before new row
      }

      itemsInRow += 1;

      // full row or last item in row
      const isLastItem = i === items.length - 1;
      if (itemsInRow === 2 || isLastItem) {
        totalHeight += 18;
        itemsInRow = 0;
        isFirstRow = false;
      }
    }
  }

  return totalHeight;
};
